import { combineReducers } from "@reduxjs/toolkit";
import actionsUser from "./actionsUserSlice";

const toolsReducers = combineReducers({
	actionsUser,
});

export default toolsReducers;
